import { Cancel, CheckCircle, CheckCircleOutline, Circle, CloudUpload, ContentCopy, Delete, Download, Edit, Error, MenuBookOutlined, MoreVert, Refresh, Upload, Visibility, Close } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, MenuItem, Popover, Select, Slide, Stack, TextField, Tooltip, Typography,  styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRequest, postRequest } from "../../utils/ApiUtil";
import { setPageMessage, setProcessing, setTableAttributes } from "../../store/ApplicationStore";
import { apiEndpoints, appConfigs, docUploadRegex } from "../../constants/ApplicationConstants";
import { clearDocumentStore, storeDocuments } from "../../store/AdminDocumentsStore";
import { DataGrid , GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid";
import { DocumentListSerializer} from "../../serializers/DocumentSerializer";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { pageMessages } from "../../constants/MessageConstants";
import CloseIcon from '@mui/icons-material/Close';
import { useHandleError } from "../others/ErrorScreen";
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { ReactComponent as SaveIcon } from "../../assets/images/floppy-disk-light.svg"
import { initialBulkDocs, setBulkUploadDocs, setOriginalBulkDocs, setUploadValidationDocs } from "../../store/BulkUploadStore";
import _ from 'lodash';
import DocViewer from '../../components/DocViewer';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const getTogglableColumns = (columns) => {
    return columns
      .filter((column) => !['document_name','__check__'].includes(column.field))
      .map((column) => column.field);
  };

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function GridWithBorder({children,...props}){
    return (
        <Grid {...props} style={{ border: '1px solid #E9EAEE', padding: '0.5rem' }} >
                {children} 
        </Grid>
    )
}

export default function KnowledgeManagerScreen(){
    const { user } = useSelector(state=> state.user)
    const { documents } = useSelector(state => state.admindocuments);
    const { adminmenu } = useSelector(state => state.adminmenu);
    const { tableAttributes } = useSelector(state => state.app);
    const [ selectedDomain, setSelectedDomain ] = useState(null);
    const [ showUploadPop, setShowUploadPop ] = useState(false);
    const [ showEditPop, setShowEditPop ] = useState(false);
    const [ showDeletePop, setShowDeletePop ] = useState(false);
    const [ showDeleteMultiPop, setShowDeleteMultiPop ] = useState(false);
    const [ showMasterSOPPop, setShowMasterSOPPop ] = useState(false);
    const [ showMasterSOPSuccessPop, setShowMasterSOPSuccessPop ] = useState(false);
    const [ documentFile, setDocumentFile ]= useState(null);
    const [ documentName, setDocumentName ]= useState("");
    const [ documentProcess, setDocumentProcess ]= useState(null);
    const [ documentSubProcess, setDocumentSubProcess ]= useState(null);
    const [ documentValidUpto, setDocumentValidUpto ]= useState(getThreeMonthsDate());
    const [ documentOwner, setDocumentOwner ]= useState("");
    const [ legalApprovals, setLegalApprovals ]= useState(false);
    const [ selectedRecord, setSelectedRecord ]= useState(null);
    const [ selectedRecords, setSelectedRecords ]= useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const dispatch= useDispatch();
    const handleError=useHandleError()
    const [disableReset,setDisableReset]=useState(true)
   
    const [showBulkUpload,setShowBulkUpload]=useState(false);
    const [showValidationInProgress,setShowValidationInProgress]=useState(false);
    const [showValidationPopUp,setShowValidationPopUp]=useState(false);

    const [generatedToken,setGeneratedToken]=useState('');
    const [bulkUploadStage,setBulkUploadStage]=useState(null);

    const {bulkUploadDocs, originalBulkDocs, uploadValidationDocs}=useSelector(state=>state.bulkupload);

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const uploadPopRef=useRef(null)
    const editPopRef=useRef(null)
    const validationPopRef=useRef(null)
    const [disableBulkSubmit,setDisableBulkSubmit]=useState(false);

    const [ showDocumentViewer, setShowDocumentViewer ] = useState(false);
    const [ documentObject, setDocumentObject ] = useState(null);

    const handleCopyClick = () => {
      navigator.clipboard.writeText(generatedToken);
      setTooltipOpen(true);
      setTimeout(() => {
        setTooltipOpen(false);
      }, 2000); // Hide the tooltip after 2 seconds
    };

    useEffect(() => {
        if ( showUploadPop &&  uploadPopRef.current) {
            uploadPopRef.current.scrollTop = 0;
        }
        else if( showEditPop&& editPopRef.current)
        {
            editPopRef.current.scrollTop=0;
        }
        else if(showValidationPopUp && validationPopRef.current)
        {
            validationPopRef.current.scrollTop=0;
        }
    }, [showUploadPop,showValidationPopUp,showEditPop]);


    async function fetchDocumentList(params, domain){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.documents, {...tableAttributes, ...params, domain_id: domain});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(storeDocuments(DocumentListSerializer(response.data)))   
                dispatch(setTableAttributes({ ...tableAttributes, ...params}))         
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }

    function handleMultipleRowSelection(params){
        setSelectedRecords(params)
    }

    useEffect(()=>{
        if(!selectedDomain){
            dispatch(clearDocumentStore());
        }
        dispatch(setTableAttributes(appConfigs.tableAttributes));
    },[dispatch, selectedDomain])

    function handleDragEnter(e){
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }
    
    function handleDragLeave(e){
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }
    
    function handleDragOver(e){
        e.preventDefault();
        e.stopPropagation();
        if( e.dataTransfer)
            e.dataTransfer.dropEffect = 'copy';
    }
    
    function handleDrop(e){
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          handleFile(e.dataTransfer.files[0]);
          e.dataTransfer.clearData();
        }
    }

    function handleFile(file){
        try{
            if(file && file.size<appConfigs.allowedFileSize*1024*1024 ){
                setLegalApprovals(false)
                let filename = file.name;
                if(file.size === 0){
                    dispatch(setPageMessage({type: 'error', message:  pageMessages.emptyFile}))
                    return
                }         
                const allowedList= appConfigs.allowedFileTypes;
                if(allowedList.some(substring => filename.includes(substring))){
                    if(!docUploadRegex.test(file.name))
                    {
                        dispatch(setPageMessage({type: 'error', message:  pageMessages.fileName}))
                        return
                    }
                    else
                    {
                        setDocumentName(filename);
                        setDocumentFile(file)
                    }                
                }else{
                    dispatch(setPageMessage({type: 'error', message: pageMessages.fileSize}))
                    return null
                }           
            }else{
                //dispatch(setPageMessage({type: 'error', message:  pageMessages.fileSize}))     
                return null
            }
        }catch(err){
            handleError(err)
        }
    
    }

    function handleUploadPopToggle(){
        if(showUploadPop){
            setShowUploadPop(false); setDocumentName(""); setDocumentFile("");
            setDocumentProcess(null); setDocumentSubProcess(null);
            setDocumentValidUpto(getThreeMonthsDate()); setDocumentOwner("");
            setLegalApprovals(false); setShowBulkUpload(false); 
            dispatch(setBulkUploadDocs()); dispatch(setOriginalBulkDocs()); 
            setGeneratedToken('') ;   
        }else{
            setShowBulkUpload(false)  
            setDisableReset(true)    
            getBulkUploadStage()           
        }
    }

    function  updateBulkUploadName(value){
        dispatch(setBulkUploadDocs({...bulkUploadDocs,bulk_upload_name:value}))
        setDisableReset(false) 
    }

    function getThreeMonthsDate(){
        const today = new Date();
        today.setMonth(today.getMonth() + 3);
        return today.toISOString().split('T')[0];
    }

    async function generateToken(){  
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.generateSasToken);
     
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                response &&  response.data &&  setGeneratedToken(response.data.sas_url)
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }       
        catch(err){
            handleError(err)
        }    
    }

    function addNewRowToBulkUpload(index){
      try
      {
        if(bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents[index] &&  bulkUploadDocs.documents[index].docs )
        {
            if(!bulkUploadDocs.documents[index].sub_process.id)
                {
                    dispatch(setPageMessage({message:'Please select menus from dropdown', type: "error"}));
                    return ;
                }
            
            const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))
            updatedDocs.documents[index].docs.push(  {
                file_name: '',
                valid_upto: getThreeMonthsDate(),
                owner: user && user.fullname,
                id:null
                })
            setDisableReset(false)
            dispatch(setBulkUploadDocs(updatedDocs))
        }   
      }
      catch(err)
      {
        handleError(err)
      }     
    }

    function  addMappingCheck(){
        const arr=bulkUploadDocs && bulkUploadDocs.documents
        const arrLength=arr.length-1
        if(arr &&  arrLength >=0 )
        {
           if( arr[arrLength].sub_process   && arr[arrLength].sub_process.name && arr[arrLength].sub_process.name.trim() === '')
            return false
           else if(arr[arrLength].docs && arr[arrLength].docs.length===0)
            return false
        return true
            
        }
        else
        {
            return false
        }    
    }

    function addNewMappingToBulkUpload(){
      try
      {  
        if(addMappingCheck())
        {
            const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))
            updatedDocs.documents.push({
                domain: {
                    id: null,
                    name: ''
                },
                process: {
                    id: null,
                    name: ''
                },
                sub_process: {
                    id: null,
                    name: ''
                },
                docs: []            
                })
            dispatch(setBulkUploadDocs(updatedDocs))
            setDisableReset(false)
        }
        else
        {
            dispatch(setPageMessage({message:'Please complete previous mapping', type: "error"})); 
        }
      }
      catch(err)
      {
        handleError(err)
      }       
    }

    function removeRowFromBulkUpload(index,docIndex){
        //check if it already exist in orignialdocs(from api),else don't call api
        try
        {
            if(originalBulkDocs && originalBulkDocs.documents &&  originalBulkDocs.documents.length && bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents.length)
            {
                const processIndex =originalBulkDocs.documents.map(obj=>obj.sub_process.id).findIndex(val=>val===bulkUploadDocs.documents[index].sub_process.id)
                if( processIndex===-1)
                {
                    const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))
                    updatedDocs.documents[index].docs.splice(docIndex, 1);
                    dispatch(setBulkUploadDocs(updatedDocs))  
                }
                else
                { 
                    const obj=bulkUploadDocs.documents[index].docs[docIndex]
                    const fileIndex=originalBulkDocs.documents[processIndex].docs.findIndex(val=>val.file_name=== obj.file_name && val.valid_upto===obj.valid_upto && val.owner ===obj.owner)
                    if(fileIndex===-1)
                    {              
                        const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))
                        updatedDocs.documents[index].docs.splice(docIndex, 1);
                        dispatch(setBulkUploadDocs(updatedDocs))
                    }
                    else
                    {
                        deleteFile(index,docIndex,processIndex,fileIndex)    
                    }
                }
            }
        }
        catch(err)
        {
            handleError(err)
        }  
    }

    async function deleteFile(index ,docIndex,processIndex,fileIndex){
        try
        {
            if(bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents[index] && bulkUploadDocs.documents[index].docs && bulkUploadDocs.documents[index].docs.length )
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteFileRow,{id:bulkUploadDocs.documents[index].docs[docIndex].id});
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))
                    updatedDocs.documents[index].docs.splice(docIndex, 1);
                    dispatch(setBulkUploadDocs(updatedDocs))  
        
                    const updateOriginalDocs=JSON.parse(JSON.stringify(originalBulkDocs))
                    updateOriginalDocs.documents[processIndex].docs.splice(fileIndex, 1);
                    dispatch(setOriginalBulkDocs((updateOriginalDocs)))
        
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                }
            } 
        }
        catch(err)
        {
            handleError(err)
        }        
    }

    async function removeRowFromValidationUpload(fileIndex,validationKey){
        try{
            if(uploadValidationDocs && uploadValidationDocs[validationKey] && uploadValidationDocs[validationKey][fileIndex] )
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteFileRow,{id:uploadValidationDocs[validationKey][fileIndex].id});
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }
                else
                {
                    const updatedDocs=JSON.parse(JSON.stringify(uploadValidationDocs));
                    updatedDocs[validationKey].splice(fileIndex, 1);
                    dispatch(setUploadValidationDocs(updatedDocs));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))  
                }                   
            }          
        }
        catch(err)
        {
            handleError(err)
        }   
    }

   

    async function  resetValidationDocs(){
        try
        {
            if(uploadValidationDocs)
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.resetBulkUpload,{id:uploadValidationDocs.bulk_upload_id});
            
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    setShowValidationPopUp(false)
                    dispatch(setUploadValidationDocs())                
                    dispatch(setProcessing(false))
                    dispatch(setPageMessage({message: response.message, type: "success"}));                                   
                    fetchDocumentList({column: 'date_of_insert'},selectedDomain)
                }
            } 
        }
        catch(err)
        {
            handleError(err)
        } 
    }

    function resetBulkUpload()
    {  
        dispatch(setBulkUploadDocs(originalBulkDocs))     
        setDisableReset(true)   
    }

    async function resetAllBulkUpload()
    {   
        try
        {
            if(bulkUploadDocs)
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.resetBulkUpload,{id:bulkUploadDocs.bulk_upload_id});
            
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(setBulkUploadDocs())
                    dispatch(setOriginalBulkDocs())
                    setShowUploadPop(false); 
                    setShowBulkUpload(false);
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                    fetchDocumentList({column: 'date_of_insert'},selectedDomain)
                }
            } 
        }
        catch(err)
        {
            handleError(err)
        }          
    }
 
    function preparePayload(){
       try
       {
        const docsWithProcess= bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents.filter(bulkDocs=>bulkDocs.sub_process.id  && bulkDocs.process.id  && bulkDocs.domain.id)
        const docsWithFiles= docsWithProcess && docsWithProcess.map(doc=>({...doc,docs:doc.docs && doc.docs.filter(obj=>obj.file_name && obj.valid_upto && obj.owner &&  obj.file_name.trim() && obj.owner.trim())}))
        const filteredDocs= docsWithFiles && docsWithFiles.filter(obj=>obj.docs && obj.docs.length>0)
        return {...bulkUploadDocs,documents:filteredDocs}
       }
       catch(err)
       {
        handleError(err)
       }

    }
    
    async function saveBulkUploadProgress(){
        try
        {
            const payload =preparePayload()
            if(payload && payload.documents && payload.documents.length>0  && _.isEqual(payload, bulkUploadDocs))
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.saveBulkUpload, payload);
            
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    response && dispatch(setBulkUploadDocs(response.data)); 
                    response && response.data && dispatch(setOriginalBulkDocs((JSON.parse(JSON.stringify(response.data)) )))
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                    setDisableReset(true);
                }
            }
            else
            {
                dispatch(setPageMessage({message: 'please fill all the field(s) or remove row(s)', type: "error"}));
            }
        }
        catch(err)
        {
            handleError(err)
        }
    }

    async function submitBulkUpload(){
        try
        {
            const payload =preparePayload()
            if(payload && payload.documents &&  payload.documents.length>0  && _.isEqual(payload, bulkUploadDocs))
            {
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.submitBulkUpload, payload);    
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(setProcessing(false))
                    setShowUploadPop(false); 
                    setShowBulkUpload(false); 
                    dispatch(setBulkUploadDocs())
                    dispatch(setOriginalBulkDocs())
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    fetchDocumentList({column: 'date_of_insert'},selectedDomain)                 
                }
            } 
            else
            {
                dispatch(setPageMessage({message:'please fill all the field(s) or remove row(s)', type: "error"})); 
            } 

        }
        catch(err)
        {
            handleError(err)
        }

    }

    function updateBulkUploadDocsMenu(value,index,level)
    {   
        try
        {
            if(level==='sub_process')
            {
                const array=bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents.map(t=>t.sub_process.id)
                if(new Set(array).has(value))
                {
                    dispatch(setPageMessage({message:'Duplicate Mapping', type: "error"}));
                    return;
                }          
            } 
            if(bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents.length)
            {     
                const arr=adminmenu && adminmenu.filter(menu=>menu.id===value)
                if(arr && arr.length)
                {   const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs))          
                    updatedDocs.documents[index][level] = {id:value,name: arr[0].name}; 
                    if(level==='domain')
                    {
                        updatedDocs.documents[index].process = {id:null,name: ''}; 
                        updatedDocs.documents[index].sub_process = {id:null,name: ''}; 
                    }
                    else if(level==='process')
                    {
                        updatedDocs.documents[index].sub_process = {id:null,name: ''}; 
                    }   
                    dispatch(setBulkUploadDocs(updatedDocs));
                    setDisableReset(false) 
                }    
            }
        }
        catch(err)
        {
            handleError(err)
        }

    }

    function updateBulkUploadDocsFileData(value, index, docIndex, key) {
        try
        {
            if(bulkUploadDocs && bulkUploadDocs.documents && bulkUploadDocs.documents[index] && bulkUploadDocs.documents[index].docs  && bulkUploadDocs.documents[index].docs.length)
            {
                const updatedDocs=JSON.parse(JSON.stringify(bulkUploadDocs));   
                updatedDocs.documents[index].docs[docIndex][key] = value;
                dispatch(setBulkUploadDocs( updatedDocs))  
                setDisableReset(false)                       
            }
        }
        catch(err)
        {
            handleError(err)
        }
    }

    function updateValidationFileData(value,docIndex, key,validationKey){
        try
        {            
            if(uploadValidationDocs && uploadValidationDocs[validationKey] && uploadValidationDocs[validationKey][docIndex] )
            {
                const updatedDocs=JSON.parse(JSON.stringify(uploadValidationDocs));
                updatedDocs[validationKey][docIndex][key] = value;
                dispatch(setUploadValidationDocs(updatedDocs));
            }
        }
        catch(err)
        {
            handleError(err)
        }
    }

   function updateValidationDocsMenu(value,index,level,validationKey)
   {
       try
       {
        if(uploadValidationDocs && uploadValidationDocs[validationKey] &&  uploadValidationDocs[validationKey][index] )
        {           
            const arr=adminmenu && adminmenu.filter(menu=>menu.id===value)
            if(arr && arr.length)
            {
                const updatedDocs= JSON.parse(JSON.stringify(uploadValidationDocs))          
                if(level==='domain')
                {   updatedDocs[validationKey][index]['domain_id']=value;
                    updatedDocs[validationKey][index]['domain_name']=arr[0].name;
                    updatedDocs[validationKey][index].process_id =null;
                    updatedDocs[validationKey][index].process_name ='';
                    updatedDocs[validationKey][index].sub_process_id =null;
                    updatedDocs[validationKey][index].sub_process_name ='';
                    
                }
                else if(level==='process')                    
                {
                    updatedDocs[validationKey][index]['process_id']=value;
                    updatedDocs[validationKey][index]['process_name']=arr[0].name;
                    updatedDocs[validationKey][index].sub_process_id =null;
                    updatedDocs[validationKey][index].sub_process_name ='' ;                
                }
                else
                {
                    updatedDocs[validationKey][index]['sub_process_id'] = value ;
                    updatedDocs[validationKey][index]['sub_process_name'] =arr[0].name;
                }
                dispatch(setUploadValidationDocs(updatedDocs));  
            }
        }  
       }
       catch(err)
       {
        handleError(err)
       }
 
   }

   function checkInvalidDocs(){   
    return (  uploadValidationDocs && ((uploadValidationDocs['documents_name_not_found'] && uploadValidationDocs['documents_name_not_found'].length>0 &&
        uploadValidationDocs['documents_name_not_found'].filter(k=>!(k.sub_process_id && k.file_name && k.valid_upto && k.file_name.trim() && k.owner && k.owner.trim())).length>0)||
        ((uploadValidationDocs['documents_already_present'] && uploadValidationDocs['documents_already_present'].length>0 &&
        uploadValidationDocs['documents_already_present'].filter(k=>!(k.sub_process_id && k.file_name  && k.valid_upto && k.file_name.trim() && k.owner && k.owner.trim())).length>0)) ||(
            (uploadValidationDocs['documents_size_exceeded'] && uploadValidationDocs['documents_size_exceeded'].length>0 &&
                uploadValidationDocs['documents_size_exceeded'].filter(k=>!(k.sub_process_id && k.file_name  && k.valid_upto && k.file_name.trim() && k.owner && k.owner.trim())).length>0)
        )))
   }

   async function handleValidationSubmit(){
    try
    {
        if(!checkInvalidDocs())
        {
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.submitValidationDocs,uploadValidationDocs);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false));  
                setShowValidationPopUp(false) ;
                dispatch(setUploadValidationDocs());
                fetchDocumentList({column: 'date_of_insert'},selectedDomain);
            }
        }
        else
        {
            dispatch(setPageMessage({message: 'Please fill all the field(s)', type: "error"}));
        }
    
    }
    catch(err)
    {
        handleError(err)
    }
   }

   async function fetchBulkUploadDocs()
   {
    try
    {
        if(bulkUploadStage===0)
        {
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.fetchBulkUploadDocs);
        
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{ 
                if(response.data) 
                {
                    response.data.documents && response.data.documents.length ?    dispatch(setBulkUploadDocs(response.data)): 
                    dispatch(setBulkUploadDocs({...initialBulkDocs,bulk_upload_id:response.data.bulk_upload_id,bulk_upload_name:response.data.bulk_upload_name}))
                     response.data.documents && response.data.documents.length ? dispatch(setOriginalBulkDocs((JSON.parse(JSON.stringify(response.data)) ))):
                    dispatch(setOriginalBulkDocs({...initialBulkDocs,bulk_upload_id:response.data.bulk_upload_id,bulk_upload_name:response.data.bulk_upload_name}))
                }
                dispatch(setProcessing(false))
            }   
        }
    }
    catch(err)
    {
        handleError(err)
    }
    }
    async function fetchSubmitButtonStatus()
    {
        try
        {
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.fetchSubmitButtonStatus);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{    
                response && setDisableBulkSubmit(!response.data)
                if(!(response && response.data))
                {
                    dispatch(setPageMessage({message: response.message, type: "error"}));  
                }
                dispatch(setProcessing(false))
            }
            
        }
        catch(err)
        {
            handleError(err)
        }      
    }

    async function fetchUploadValidationDocs()
    {   
        try
        {
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.fetchValidationDocs);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                response &&  dispatch((setUploadValidationDocs(response.data)))
                if(response && response.data && ((response.data.documents_name_not_found &&   response.data.documents_name_not_found.length>0)|| 
                (response.data.documents_already_present && response.data.documents_already_present.length>0 ) || (response.data.documents_size_exceeded
                    && response.data.documents_size_exceeded
                    .length>0 ) ) )
                {
                    setShowValidationPopUp(true);
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                }
                else
                {                 
                   setBulkUploadStage(0);
                   setShowUploadPop(true);                  
                }      
                dispatch(setProcessing(false));     
            }
        }
        catch(err)
        {
            handleError(err)
        }

    }

   async function getBulkUploadStage(){
    try
    {
        dispatch(setProcessing(true));
        const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.bulkUploadStatus);
        if(response.isError){
            dispatch(setProcessing(false));
            dispatch(setPageMessage({message: response.message, type: "error"}));
        }else{             
            dispatch(setProcessing(false));
    
            if(response.data)
            {
                setBulkUploadStage(response.data.stage)
                if(response.data.stage===1)
                {   //---------validation in progress --------- 
                    setShowUploadPop(false);
                    setShowValidationInProgress(true);
                }    
                else if(response.data.stage===3)
                {   //---------upload failed --------- 
                    setShowUploadPop(false);             
                    fetchUploadValidationDocs();
                }
                else
                {
                    setShowUploadPop(true );
                }        
            }
            else
            {
                setBulkUploadStage(null);
                dispatch(setBulkUploadDocs())
                dispatch(setOriginalBulkDocs())
                setShowUploadPop(true ); 
            }  
        }
    }
    catch(err)
    {
        handleError(err)
    }

   }

    function handleEditPopToggle(record){
        try{
            if(showEditPop){
                setShowEditPop(false); setSelectedRecord(null);
                setDocumentName(""); setDocumentFile("");
                setDocumentProcess(null); setDocumentSubProcess(null);
                setDocumentValidUpto(getThreeMonthsDate()); setDocumentOwner("");
                setLegalApprovals(false);
            }else{
                const validupto= record.valid_upto;
                if( validupto && validupto.indexOf('T')>-1){
                    let temp = validupto.split('T');
                    setDocumentValidUpto(temp[0])
                }else{
                    setDocumentValidUpto(validupto)
                }
                setShowEditPop(true);setSelectedRecord(record);
                setDocumentName(record.document_name); setDocumentFile(record.document_url);
                setDocumentProcess(record.process_id); setDocumentSubProcess(record.sub_process_id);
                setDocumentOwner(record.document_owner); setLegalApprovals(record.is_approved);
            }
        }catch(err){
            handleError(err)
        }    
    }
    async function handleUploadSubmit(){
        try{
            dispatch(setProcessing(true));
            if(documentProcess&& documentSubProcess&& documentName&& documentOwner && documentOwner.trim()!=="" && documentValidUpto&& documentFile && legalApprovals){
                let formdata= new FormData();
                formdata.append("file_name",documentName);
                formdata.append("file", documentFile);
                formdata.append("sub_process_id", documentSubProcess)
                formdata.append("process_id", documentProcess)
                formdata.append("domain_id", selectedDomain)
                formdata.append("owner", documentOwner.trim())
                formdata.append("valid_upto", documentValidUpto)
    
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.docUpload, formdata);
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    setShowEditPop(false);
                    setShowUploadPop(false);   setShowBulkUpload(false); setSelectedRecord(null);
                    setDocumentName(""); setDocumentFile("");
                    setDocumentProcess(null); setDocumentSubProcess(null);
                    setDocumentValidUpto(getThreeMonthsDate()); setDocumentOwner("");
                    setLegalApprovals(false);
                    // const docs= DocumentSerializer(response.data)
                    // if(docs)
                    //     dispatch(addDocumentToStore(docs))                   
                    fetchDocumentList({column: 'date_of_insert'},selectedDomain)
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false));
                }
            }else{
                dispatch(setPageMessage({message: pageMessages.docUpload, type: "error"}));
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }     
    }
    async function handleEditSubmit(){
        try{
            dispatch(setProcessing(true))
            if(!(documentProcess===selectedRecord.process_id&&documentSubProcess===selectedRecord.sub_process_id&&documentName===selectedRecord.document_name&&documentOwner===selectedRecord.document_owner&&documentValidUpto===selectedRecord.valid_upto&& documentFile===selectedRecord.document_url)){
                if(documentOwner.trim()!==""){
                    let formdata= new FormData();
                    formdata.append("id",selectedRecord.id);
                    formdata.append("file_name",documentName);
                    documentFile!==selectedRecord.document_url&&formdata.append("file", documentFile);
                    formdata.append("sub_process_id", documentSubProcess)
                    formdata.append("process_id", documentProcess)
                    formdata.append("domain_id", selectedDomain)
                    formdata.append("owner", documentOwner.trim())
                    formdata.append("valid_upto", documentValidUpto)
        
                    const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.docEdit, formdata);
                    if(response.isError){
                        dispatch(setProcessing(false));
                        dispatch(setPageMessage({message: response.message, type: "error"}));
                    }else{
                        fetchDocumentList({column: 'date_of_insert'},selectedDomain);
                        setShowEditPop(false); setSelectedRecord(null);
                        dispatch(setPageMessage({message: response.message, type: "success"}));
                        dispatch(setProcessing(false));
                    }
                }else{
                    dispatch(setPageMessage({message: pageMessages.notValidOwnerName, type: "error"}));
                    dispatch(setProcessing(false));
                }
            }else{
                dispatch(setPageMessage({message: pageMessages.docEditNochange, type: "error"}));
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }    
    }
    async function handleDeleteSubmit(){
        setShowDeletePop(false);
        selectedRecord && handleMultiDeleteSubmit([selectedRecord.id]);
    }
    async function handleMultiDeleteSubmit(records){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.docDelete, {"ids": records});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{               
                setSelectedRecords([]); setShowDeleteMultiPop(false); setShowDeletePop(false);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false));
                fetchDocumentList({column: 'date_of_insert'},selectedDomain);
            }
        }catch(err){
            handleError(err)
        }      
    }
    async function handleMultipleDownload(records){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.multidownload, {"ids": records});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const decodedByteArray = atob(response.data);
                const byteArray = new Uint8Array(decodedByteArray.length);
                for (let i = 0; i < decodedByteArray.length; i++) {
                byteArray[i] = decodedByteArray.charCodeAt(i);
                }
                const blob = new Blob([byteArray], { type: 'application/json' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "download.zip";
                link.click();
                window.URL.revokeObjectURL(link.href);
                setSelectedRecords([]);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }   
    }
    async function handleDocumentRefresh(){
        fetchDocumentList({column: 'date_of_insert'},selectedDomain);
    }
    async function handleMasterSOPSubmit(records){
        try{
            dispatch(setProcessing(true));
            if(records.length > appConfigs.masterSOPDocLimit){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: pageMessages.sopMaxLimit, type: "error"}));
            }else{
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.masterSOP, records);
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                    setShowMasterSOPPop(false);
                    setSelectedRecords([]);
                }else{
                    setShowMasterSOPPop(false);
                    setSelectedRecords([]); 
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false));
                    setShowMasterSOPSuccessPop(true);
                } 
            }
        }catch(err){
            handleError(err)
        }     
    }
    function formatDate(value){
        const date = new Date(value);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        return formattedDate
    }
    const base64ToBlob = (base64String) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    }

    async function handleFileExplorer(path, page, image){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.loadDocument, {"file_path": path});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const blob = image ? response.data : base64ToBlob(response.data);
                const blobUrl = image ? response.data : URL.createObjectURL(blob);
                page ? setDocumentObject(blobUrl+"#page="+page) : setDocumentObject(blobUrl);
                image ? setShowDocumentViewer(false) : setShowDocumentViewer(true);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }
        catch(err){
            handleError(err)
        }    
    }
    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box>
                        <Box display='flex'>
                            <MenuBookOutlined sx={{marginRight: '1rem',marginTop:'0.1rem'}}/>
                            <Stack direction='row' alignItems='center'>
                            <Box>
                                <Typography variant='h5'>Knowledge Manager</Typography>
                                <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Manage document activities and their mappings to various Domains.</Typography>
                            </Box>
                            <Refresh onClick={()=>fetchDocumentList({column: 'date_of_insert'},selectedDomain)} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Grid container spacing={2}>
                        <Grid item sm={12} md={6} lg={3}>
                            <FormControl size='small' fullWidth>
                                <InputLabel>Select Domain</InputLabel>
                                <Select value={selectedDomain? selectedDomain : ""} label="Select Domain" onChange={(e)=>{setSelectedDomain(e.target.value); fetchDocumentList({column: 'date_of_insert'}, e.target.value)}}>
                                    {adminmenu&&adminmenu.filter(item=> item.parent === "").map((obj)=>{
                                        return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            {selectedRecords.length>0&&<Stack direction='row' spacing={2} sx={{p:1, bgcolor: 'primary.main', borderRadius: '5px', color: (theme)=>theme.palette.primary.contrastText}}>
                                    <Box display='flex' alignItems='center'><MoreVert /></Box>
                                    <Box display='flex' alignItems='center'><Typography>{selectedRecords.length} Document(s) Selected</Typography></Box>
                                    {appConfigs.allowDocDownload && <Box sx={{cursor: 'pointer'}} display='flex' alignItems='center' onClick={()=>{handleMultipleDownload(selectedRecords)}}>
                                        <Download sx={{marginRight: 1}} />
                                        <Typography>Download</Typography>
                                    </Box>}
                                    <Box sx={{cursor: 'pointer'}} display='flex' alignItems='center' onClick={()=>{setShowDeleteMultiPop(true)}}>
                                        <Delete sx={{marginRight: 1}} />
                                        <Typography>Delete</Typography>
                                    </Box>
                                    {appConfigs.allowMasterSop && appConfigs.allowMasterSop.toLowerCase() ==='y' && selectedRecords.length>1&&<Box sx={{cursor: 'pointer'}} display='flex' alignItems='center' onClick={()=>{setShowMasterSOPPop(true)}}>
                                        <MenuBookOutlined sx={{marginRight: 1}} />
                                        <Typography>Generate Master SOP</Typography>
                                    </Box>}
                                    <Box  sx={{cursor: 'pointer'}}  display='flex' alignItems='center' onClick={()=>{setSelectedRecords([])}}>                         
                                        <CloseIcon />
                                    </Box>
                                
                            </Stack>}
                        </Grid>
                        <Grid item sm={12} md={6} lg={3}>
                           {selectedDomain && selectedDomain!==""  && <Button sx={{ float: 'right', textTransform: 'capitalize' }} startIcon={<CloudUpload />} onClick={()=>handleUploadPopToggle()} variant="contained" color="primary">Upload Document</Button>}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {documents && selectedDomain && selectedDomain !=="" && <DataGrid
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                            },
                            },
                        }}
                        slotProps={{
                            filterPanel: {
                                filterFormProps:{
                                    operatorInputProps:{
                                        sx:{
                                            display: 'none'
                                        }
                                    }
                                }
                            },
                            columnsManagement: {
                                getTogglableColumns,
                              },
                        }}                      
                        disableRowSelectionOnClick
                        rowHeight={75}
                        autoHeight
                        rows={documents.records}
                        columns={[
                            {  ...GRID_CHECKBOX_SELECTION_COL_DEF,hideable: false},
                            { field: 'document_name', hideable: false,  headerName: 'Document Name', width: 150},
                            { field: 'process_name', headerName: 'Process', width: 200},
                            { field: 'sub_process_name', headerName: 'Sub Process', width: 200},
                            { field: 'document_owner', headerName: 'Owner', width: 100 },
                            { field: 'valid_upto', headerName: 'Valid Upto', filterable: false, disableColumnMenu: true, width: 150, valueGetter: (value) => formatDate(value)},
                            { field: 'date_of_insert', headerName: 'Uploaded On', filterable: false, disableColumnMenu: true, width: 150, valueGetter: (value) => formatDate(value) },
                            { field: 'status', headerName: 'Document Status', filterable: false, disableColumnMenu: true, width: 250, renderCell: (params) => (
                                <Box display='flex' flexDirection='row' mt={1}>
                                    <Box display='flex' flexDirection='column' alignItems='center'>
                                        {parseInt(params.row.status)===0 && <Error sx={{color: 'orange'}} /> }
                                        {(parseInt(params.row.status)===1 || parseInt(params.row.status)===3 || parseInt(params.row.status)===4 || parseInt(params.row.status)===5) && <CheckCircle color="success" /> }
                                        {parseInt(params.row.status)===2 && <Cancel color="red" /> }
                                        <Typography sx={{fontSize: '0.6rem'}}>{params.row.action_details.charAt(0).toUpperCase() + params.row.action_details.slice(1)}</Typography>
                                        {parseInt(params.row.status)===0 && <Typography color='orange' sx={{fontSize: '0.4rem'}}>In Progress</Typography>}
                                        {(parseInt(params.row.status)===1 || parseInt(params.row.status)===3 || parseInt(params.row.status)===4 || parseInt(params.row.status)===5)  && <Typography color='green' sx={{fontSize: '0.4rem'}}>Success</Typography>}
                                        {parseInt(params.row.status)===2 && <Typography color='red' sx={{fontSize: '0.4rem'}}>Failed</Typography>}
                                    </Box>
                                    <Box sx={{borderTop: '1px solid grey', width:'3rem', mt: 2}} />
                                    <Box display='flex' flexDirection='column' alignItems='center'>
                                        {(parseInt(params.row.status)===0  || parseInt(params.row.status)===1 || parseInt(params.row.status)===2) && <Circle sx={{color: 'grey'}} /> }
                                        {(parseInt(params.row.status)===3 )  && <Error sx={{color: 'orange'}} /> }
                                        {(parseInt(params.row.status)===4 ) && <CheckCircle sx={{color: 'green'}} /> }
                                        {(parseInt(params.row.status)===5 ) && <Cancel sx={{color: 'red'}} /> }
                                        <Typography sx={{fontSize: '0.6rem'}}>Embeddings</Typography>
                                        {(parseInt(params.row.status)===0 || parseInt(params.row.status)===1 )  && <Typography color='grey' sx={{fontSize: '0.4rem'}}>In Queue</Typography> }
                                        {(parseInt(params.row.status)===3 )&& <Typography color='orange' sx={{fontSize: '0.4rem'}}>In Progress</Typography>  }
                                        {(parseInt(params.row.status)===4 ) && <Typography color='green' sx={{fontSize: '0.4rem'}}>Success</Typography> }
                                        {(parseInt(params.row.status)===5 ) && <Typography color='red' sx={{fontSize: '0.4rem'}}>Failed</Typography>  }
                                    </Box>
                                </Box>
                            )},
                            { field: 'customField', headerName: 'Actions', sortable: false, width: 150, filterable: false, disableColumnMenu: true, renderCell: (params) => (
                                <PopupState variant="popover">
                                    {(popupState) => (
                                    <>
                                        <MoreVert sx={{cursor: 'pointer', mt: 3}} {...bindTrigger(popupState)} />
                                        <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'center', horizontal: 'right' }} >
                                            <List sx={{p: 2}}>
                                                {parseInt(params.row.status)===4&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleFileExplorer(params.row.document_path, null, false); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Visibility  sx={{marginRight: '1rem'}} />
                                                        <Typography>View</Typography>
                                                    </Box>
                                                </ListItem>}
                                                 {(parseInt(params.row.status)===4||parseInt(params.row.status)===5)&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleEditPopToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Edit  sx={{marginRight: '1rem'}} />
                                                        <Typography>Edit</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {(parseInt(params.row.status)===4 || parseInt(params.row.status)===2||parseInt(params.row.status)===5)&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{setShowDeletePop(true); setSelectedRecord(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Delete  sx={{marginRight: '1rem'}} />
                                                        <Typography>Delete</Typography>
                                                    </Box>
                                                </ListItem>}
                                                <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleDocumentRefresh(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Refresh  sx={{marginRight: '1rem'}} />
                                                        <Typography>Refresh</Typography>
                                                    </Box>
                                                </ListItem>
                                            </List>
                                        </Popover>
                                    </>
                                    )}
                                </PopupState>  
                            )},                  

                        ]}
                        pagination
                        initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize:appConfigs.tableAttributes.size,
                                page: 0,
                              },
                            }
                        }}
                        pageSizeOptions={appConfigs.tablePageOptions}
                        paginationMode='server'
                        sortingMode="server"
                        onSortModelChange={(param)=>fetchDocumentList(param[0]?{column:param[0].field, order: param[0].sort}:{column: "date_of_insert"}, selectedDomain)}
                        rowCount={documents.total_elements}
                        onPageChange={(param)=>fetchDocumentList({column:param[0].field, order: param[0].sort}, selectedDomain)}
                        onPaginationModelChange={(param)=>fetchDocumentList({page: param.page+1, size:param.pageSize, column: "date_of_insert"}, selectedDomain)}
                        filterMode="server"
                        onFilterModelChange={(param)=>fetchDocumentList(param.items[0]?{column:param.items[0].field, search: param.items[0].value}:{column: "date_of_insert"}, selectedDomain)}
                        checkboxSelection                    
                        rowSelectionModel={selectedRecords}
                        isRowSelectable={(params) => params.row.status !== 0 && params.row.status !== 1 && params.row.status !== 3 }
                        onRowSelectionModelChange={(params)=>handleMultipleRowSelection(params)}
                    /> }
                </Grid>
            </Grid>
            <Dialog fullWidth open={showUploadPop } TransitionComponent={Transition} keepMounted  onClose={(_,reason)=>{ if (reason === 'backdropClick'){return ;} handleUploadPopToggle()}}>
                <DialogTitle>Upload Document
                <IconButton
                    aria-label="close"
                    onClick={handleUploadPopToggle}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'grey'
                    }}
                >
                       <CloseIcon />
                </IconButton>           
                </DialogTitle>
                <DialogContent ref={uploadPopRef}>
                    <Stack direction='row' spacing={3}
                    sx={{  
                        bgcolor:'light.main',
                        color:'light.contrastText',
                        border: '1px solid #EBEBEB',
                        borderRadius:'0.5rem',
                        padding: '0.5rem'  }}>
                        <Box component="div" sx={{
                            width: '50%',
                            padding: '0.5rem',
                            textAlign: 'center',
                            borderRadius:'0.5rem',
                            fontWeight:'bold',
                            border :!showBulkUpload?'1px solid light.contrastText' : 'none',                 
                            bgcolor:!showBulkUpload? 'white.main':'inherit',
                            cursor:'pointer'}}   onClick={()=>setShowBulkUpload(false)}>Single File Upload</Box>
                        <Box component="div" sx={{
                            width: '50%',
                            padding: '0.5rem',
                            textAlign: 'center',
                            borderRadius:'0.5rem',
                            fontWeight:'bold',
                            border :showBulkUpload?'1px solid light.contrastText' : 'none',   
                            bgcolor:showBulkUpload? 'white.main':'inherit',
                           
                            cursor:'pointer'}}  onClick={()=>{setShowBulkUpload(true); fetchBulkUploadDocs() ;fetchSubmitButtonStatus();}}>Bulk Upload</Box>
                    </Stack>
                    {!showBulkUpload &&<Box sx={{marginTop: '1rem'}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        border: '2px dashed #aaa',
                                        borderRadius: '4px',
                                        padding: '20px',
                                        textAlign: 'center',
                                        backgroundColor: isDragging ? '#f0f0f0' : '#fff',
                                        cursor: 'pointer',
                                    }}
                                    onDragEnter={handleDragEnter}
                                    onDragLeave={handleDragLeave}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                    onClick={() => document.getElementById('fileInput').click()}
                                    >
                                    <Upload/>
                                    <Typography variant="body1">
                                        {isDragging ? 'Drop your file here' : 'Drag and drop a file here or click to upload'}
                                    </Typography>
                                    <VisuallyHiddenInput
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=>handleFile(e.target.files[0])}
                                    />
                                    <Typography variant="subtitle2">Supported File Formats: 
                                        {appConfigs.allowedFileTypes.map((type)=>{
                                            return " "+type+" "
                                        })}
                                    </Typography>
                                    {documentName&&<Typography color='secondary.main' variant="body1" sx={{wordWrap:'break-word'}}>{documentName}</Typography>}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth size="small" label="Document Name" variant="outlined"  sx={{wordWrap:'break-word'}} value={documentName} disabled />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Process</InputLabel>
                                    <Select sx={{padding: '0.25rem !important'}} value={documentProcess?documentProcess:''} size="small" label="Process" onChange={(e)=>{setDocumentProcess(e.target.value)}}>
                                        {adminmenu&&adminmenu.filter(item=>item.parent===selectedDomain).map((menu)=>{
                                            return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Process</InputLabel>
                                    <Select sx={{padding: '0.25rem !important'}} value={documentSubProcess?documentSubProcess:''} size="small" label="Sub Process" onChange={(e)=>{setDocumentSubProcess(e.target.value)}}>
                                        {adminmenu&&adminmenu.filter(item=>item.parent===documentProcess).map((menu)=>{
                                            return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth size="small" label="Document Owner" inputProps={{ maxLength: appConfigs.docNameCount }}  variant="outlined" value={documentOwner} onChange={(e)=>setDocumentOwner(e.target.value)} />
                                <Typography variant="body2" color="textSecondary">
                                     Max {appConfigs.docNameCount } characters allowed
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                            <TextField onKeyDown={(e)=>e.preventDefault()} fullWidth label="Valid Upto" type="date" value={documentValidUpto} onChange={(e)=>setDocumentValidUpto(e.target.value)} InputLabelProps={{shrink: true}}/>
              
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel value={legalApprovals} control={<Checkbox checked={legalApprovals} onChange={() => setLegalApprovals(!legalApprovals)} />} label="Legal Approvals done for the document?" />
                            </Grid>

                        </Grid>
                    </Box>}
                    {
                      showBulkUpload &&<Box sx={{marginTop: '1rem'}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={8}>
                                <Typography variant="h6" sx={{fontWeight:'bold'}}>Step 1 : Generate SaS Token</Typography>
                                <Typography  sx={{opacity:0.6}}>Copy & Paste the below generated token at Azure Storage Explorer to proceed upload</Typography>
                            </Grid>                    
                            <Grid item xs={12} >
                                <Stack direction='row'>
                                    <Box  sx={{ width:'50%', height :'30px', padding:"1.5rem 0.5rem",bgcolor:'light.main',border: '1px solid',borderRight: 'none',
                                    borderRadius:'9px 0px 0px 9px',                                      
                                    }} display='flex' alignItems='center' >
                                        <Typography  sx={{overflow: 'hidden',  textOverflow: 'ellipsis', whiteSpace: 'nowrap',  width: '100%',}}>{  generatedToken ? generatedToken : "Get SaS Token.."}</Typography></Box>

                                        {<Tooltip
                                        open={tooltipOpen}
                                        onClose={() => setTooltipOpen(false)}
                                        title={
                                            generatedToken &&   <Box display='flex'  justifyContent='center'><CheckCircleOutline sx={{color: 'secondary.main'}} /><Typography sx={{color: 'secondary.main'}}>Copied</Typography></Box>
                                        }
                                        slotProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: "transparent",
                                              },
                                            },
                                            popper: {
                                                modifiers: [
                                                  {
                                                    name: 'offset',
                                                    options: {
                                                      offset: [0, -18],
                                                    },
                                                  },
                                                ],
                                              },
                                          }}
                                        disableHoverListener          
                                        placement="top"
                                      >
                                        <Box  sx={{ width:'10%', height :'30px', padding:"1.5rem 0.5rem" ,border: '1px solid',borderRadius:'0px 9px 9px 0px',cursor:'pointer',bgcolor:'light.main'}} display='flex' alignItems='center' 
                                      justifyContent='center' >
                                            <ContentCopy onClick={handleCopyClick}></ContentCopy>
                                        </Box>
                                    </Tooltip>}
                                    <Box sx={{flexGrow:1}} display='flex'justifyContent="end">
                                        <Button  sx={{padding:'0 1rem',borderRadius:'0.5rem'}} color='primary' variant="contained" onClick={generateToken}  >Generate Token</Button>
                                    </Box>     
                                </Stack>
                            </Grid>
                            <Grid item xs={12}  >
                                <Divider />
                            </Grid>                      
                            <Grid item xs={12} sx={{paddingTop:'10px !important'}}>
                                <Grid container>
                                    <Grid item xs={12} sx={{paddingBottom:'5px !important'}}>
                                        <Typography variant="body1" fontSize='15px' fontWeight='bold' color="error">*{pageMessages.fileName}</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Stack>
                                            <Typography variant="h6" sx={{fontWeight:'bold'}}>Step 2 : Document Mapping</Typography>
                                            <Typography sx={{wordBreak:'break-word',opacity:0.6}}>Map the document with domain, process and sub-process</Typography>
                                        </Stack>                       
                                    </Grid>
                                    
                                    <Grid item xs={4} display='flex' alignItems='center' justifyContent='end'>
                                        <Button  startIcon={<SaveIcon />}  sx={{padding:'0.5rem 1rem',borderRadius:'0.5rem',bgcolor:'light.main',color:'light.contrastText'}}  variant="text"  onClick={()=>saveBulkUploadProgress()} > Save Progress</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                            {bulkUploadDocs &&   <TextField fullWidth size="small" label="bulk upload name" value={bulkUploadDocs.bulk_upload_name} onChange={(e)=>{updateBulkUploadName(e.target.value.trimStart())}}></TextField>}
                            </Grid>
                            <Grid item xs={12}>
                                <Box display='flex'  justifyContent='center' sx={{width:'100%',border: '1px dashed ',borderRadius: '9px',padding:'0.5rem 0',cursor:'pointer'}} onClick={()=>addNewMappingToBulkUpload()}>
                                    <AddIcon />
                                    <Typography sx={{fontWeight:'bold'}} >Add New Mapping</Typography>
                                 
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container >
                            <Grid item xs={12}>
                                {
                                    bulkUploadDocs && bulkUploadDocs.documents &&  bulkUploadDocs.documents.map((mapping,index)=>(
                                        <Box sx={{marginTop:'1rem'}} key={'bulkBox'+index} >
                                            <Grid  container  sx={{border:'1px solid #E9EAEE',borderRadius:'9px 9px 0px 0px',padding:'0.5rem'}}> 
                                                <Grid item xs={4}>
                                                        <FormControl fullWidth variant="standard" >
                                                            <InputLabel>Domain</InputLabel>
                                                            <Select  sx={{
                                                                            '&:before': {
                                                                                borderBottom: 'none',
                                                                            },
                                                                            '&:after': {
                                                                                borderBottom: 'none',
                                                                            },
                                                                            '&:hover:not(.Mui-disabled):before': {
                                                                                borderBottom: 'none',
                                                                            }}}  value={mapping?.domain?.id ?? ''} size="small" placeholder="select domain" label="Select Domain" onChange={(e)=>updateBulkUploadDocsMenu(e.target.value,index,'domain')}>
                                                           
                                                            {adminmenu&&adminmenu.filter(item=> item.parent === "").map((obj)=>{
                                                                return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                                            })}
                                                            </Select>
                                                        </FormControl>
                                                </Grid>
                                                <Grid item xs={4}>
                                                        <FormControl fullWidth variant="standard">
                                                            <InputLabel>Process</InputLabel>
                                                            <Select value={mapping?.process?.id ??''}   sx={{
                                                                            '&:before': {
                                                                                borderBottom: 'none',
                                                                            },
                                                                            '&:after': {
                                                                                borderBottom: 'none',
                                                                            },
                                                                            '&:hover:not(.Mui-disabled):before': {
                                                                                borderBottom: 'none',
                                                                            }}} size="small" label="Process" onChange={(e)=>updateBulkUploadDocsMenu(e.target.value,index,'process')}>
                                                                {adminmenu&&adminmenu.filter(item=> mapping && mapping.domain && item.parent===mapping.domain.id).map((menu)=>{
                                                                    return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                </Grid>
                                                <Grid item xs={4}>
                                                        <FormControl fullWidth variant="standard">
                                                            <InputLabel>Sub-Process</InputLabel>
                                                            <Select value={mapping?.sub_process?.id ??''}
                                                                sx={{
                                                                    '&:before': {
                                                                        borderBottom: 'none',
                                                                    },
                                                                    '&:after': {
                                                                        borderBottom: 'none',
                                                                    },
                                                                    '&:hover:not(.Mui-disabled):before': {
                                                                        borderBottom: 'none',
                                                                    }}}
                                                                             size="small" label="Sub-Process" onChange={(e)=>updateBulkUploadDocsMenu(e.target.value,index,'sub_process')}>
                                                                {adminmenu&&adminmenu.filter(item=>mapping && mapping.process && item.parent===mapping.process.id ).map((menu)=>{
                                                                    return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                </Grid>
                                            </Grid>                   
                                            <Grid container spacing={0} sx={{background:'#F5F5F5',color:'#777F9B'}}>
                                                <GridWithBorder item xs={4} >
                                                        <Typography variant="subtitle1">DOC NAME</Typography>                                                  
                                                </GridWithBorder>
                                                <GridWithBorder item xs={4}>                                                 
                                                        <Typography variant="subtitle1">VALID UPTO</Typography>                                                  
                                                </GridWithBorder>
                                                <GridWithBorder item xs={4}>                                         
                                                        <Typography variant="subtitle1">OWNER</Typography>                                                  
                                                </GridWithBorder>
                                            </Grid >
                                            {
                                                mapping.docs && <Grid container spacing={0} >{ mapping.docs.map((doc,docIndex)=>(
                                                    <>
                                                        <GridWithBorder item xs={4} >                                                                                           
                                                                <TextField 	key={`${doc.file_name}-${index}-${docIndex}bu`}  label="File Name"  variant="standard"  InputProps={{ disableUnderline: true }} fullWidth  size="small"  defaultValue={ doc?.file_name ??'' } onBlur={(e)=>{ updateBulkUploadDocsFileData(e.target.value.trimStart() ,index,docIndex,'file_name')}}  />                                                                                                                     
                                                        </GridWithBorder>
                                                        <GridWithBorder item xs={4} >
                                                            <TextField fullWidth    label="Valid Upto"  variant="standard"    inputProps={{min: new Date().toISOString().split('T')[0]}}  InputProps={{ disableUnderline: true }} 
                                                                size="small" type="date" onKeyDown={(e)=>e.preventDefault()}  value={doc?.valid_upto??''}  onChange={(e)=>{updateBulkUploadDocsFileData(e.target.value ,index,docIndex,'valid_upto')}}  InputLabelProps={{shrink: true}}/>
                                                        </GridWithBorder>
                                                        <GridWithBorder item xs={4}>
                                                                <Grid container spacing={0}>
                                                                    <Grid item xs={10}>                
                                                                        <TextField key={`${doc.owner}-${index}-${docIndex}bu`} fullWidth  variant="standard" InputProps={{ disableUnderline: true }}   size="small" label="Enter Owner Name" defaultValue={doc?.owner??''}   onBlur={(e)=>{updateBulkUploadDocsFileData(e.target.value.trimStart() ,index,docIndex,'owner')}} />
                                                                    </Grid>
                                                                                     
                                                                    <Grid item  xs={2}  sx={{pl:'0.5rem',cursor:'pointer'}} alignSelf='end' onClick={()=>removeRowFromBulkUpload(index,docIndex)}>               
                                                                        <RemoveCircleOutlineIcon  sx={{color:'#757D99'}}/> 
                                                                    </Grid>
                                                                </Grid>
                                                        </GridWithBorder>
                                                        </>
                                                ))}
                                                </Grid >  
                                            }
                                            <Grid container spacing={0}>
                                                <GridWithBorder item xs={12}  sx={{borderRadius:'0px 0px 9px 9px',color:'secondary.main'}}>                  
                                                        <Typography  sx={{cursor:'pointer'}} variant="body1" component="span" onClick={()=>addNewRowToBulkUpload(index)} > + Add Row</Typography>                    
                                                </GridWithBorder>
                                            </Grid>               
                                       </Box>
                                    ))
                                }
                            </Grid>                        
                        </Grid>
                      </Box>  
                    }
                </DialogContent>
                <DialogActions>
                {!showBulkUpload &&  <Box>
                        <Button variant='outlined' color='primary' sx={{marginRight:'1rem'}} onClick={()=>handleUploadPopToggle()}>Cancel</Button>
                        <Button disabled={!legalApprovals || !(documentOwner&& documentOwner.trim())} variant='contained' color='primary' onClick={()=> handleUploadSubmit()}>Submit</Button>
                    </Box>
                }
                {showBulkUpload && <Box>
                        <Button  disabled ={disableReset} variant='outlined' color='primary'  sx={{marginRight:'1rem'}} onClick={resetBulkUpload} >Reset</Button>
                        <Button disabled={!( originalBulkDocs && originalBulkDocs.documents && originalBulkDocs.documents.length && originalBulkDocs.documents[0].docs && originalBulkDocs.documents[0].docs.length )} variant='contained' color='secondary'  sx={{marginRight:'1rem'}} onClick={resetAllBulkUpload} >Delete All</Button>
                        <Button disabled={!(bulkUploadDocs && bulkUploadDocs.bulk_upload_name &&  bulkUploadDocs.bulk_upload_name.trim() && bulkUploadDocs.documents &&  bulkUploadDocs.documents.length && bulkUploadDocs.documents[0].docs && bulkUploadDocs.documents[0].docs.length) || disableBulkSubmit}  variant='contained' color='primary' onClick={submitBulkUpload} >Submit</Button>
                    </Box>
                }
                </DialogActions>
            </Dialog>   
            <Dialog fullWidth maxWidth="md" open={ showValidationPopUp } TransitionComponent={Transition} keepMounted  onClose={(_,reason)=>{ if (reason === 'backdropClick'){return ;} setShowValidationPopUp(false)}} >
                <DialogTitle>Upload Result
                <IconButton
                    aria-label="close"
                    onClick={()=> setShowValidationPopUp(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'grey'
                    }}
                >
                       <CloseIcon />
                </IconButton>
                </DialogTitle>
                <DialogContent ref={validationPopRef}>                 
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography sx={{fontWeight:'bold'}}>Data file(s) upload and ingestion process for all file(s) will only begin once all the issues across all files have been resolved.</Typography>
                    </Box>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography variant="body1" fontSize='15px' fontWeight='bold' color="error">*{pageMessages.fileName}</Typography>
                    </Box>
                    <Box sx={{marginTop: '1rem'}}>
                        {uploadValidationDocs && uploadValidationDocs.documents_name_not_found && uploadValidationDocs.documents_name_not_found.length>0  &&  <Accordion elevation={0} sx={{border:'1px solid #E9EAEE',borderRadius:'9px'}} >
                            <AccordionSummary  expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem',bgcolor:'light.main',color:'light.contrastText' }}  />}         
                            sx={{
                            flexDirection: 'row-reverse',  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                transform: 'rotate(90deg)',
                            }
                        }}  >
                                <Typography sx={{paddingLeft:'1rem'}}>Document(s) not found or invalid name </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{padding:0}}>
                                <Grid container spacing={0} sx={{background:'#F5F5F5',color:'#777F9B'}}>
                                    <GridWithBorder item xs={2} >                                  
                                            <Typography variant="subtitle1">DOC NAME</Typography>                                   
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                  
                                            <Typography variant="subtitle1">DOMAIN</Typography>                                  
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                
                                            <Typography variant="subtitle1">PROCESS</Typography>                                     
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                     
                                            <Typography variant="subtitle1">SUB PROCESS</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                     
                                            <Typography variant="subtitle1">VALID UPTO</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                   
                                            <Typography variant="subtitle1">OWNER</Typography>                                    
                                    </GridWithBorder>
                                </Grid >                               
                                   {  uploadValidationDocs.documents_name_not_found.map((fileData,fileIndex)=>(       
                                        <Grid container spacing={0}>
                                            <GridWithBorder item xs={2}>                                                                                            
                                                    <TextField   key={`${fileData.file_name ??''}-${fileIndex}nf`} label="Doc Name"  variant="standard"  InputProps={{ disableUnderline: true }} fullWidth  size="small"  defaultValue={ fileData?.file_name??'' } onBlur={(e)=>{ updateValidationFileData(e.target.value.trimStart() ,fileIndex,'file_name','documents_name_not_found')}}/>                                               
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>             
                                                    <FormControl fullWidth variant="standard" >
                                                        <InputLabel>Domain</InputLabel>
                                                        <Select  sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} value={fileData?.domain_id ??''} size="small" label="Select Domain" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'domain','documents_name_not_found')}>
                                                        
                                                        {adminmenu&&adminmenu.filter(item=> item.parent === "").map((menu)=>{
                                                            return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                        })}
                                                        </Select>
                                                    </FormControl>                                           
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                         
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Process</InputLabel>
                                                        <Select value={fileData?.process_id ??''}   sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} size="small" label="Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'process','documents_name_not_found')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData && item.parent===fileData.domain_id).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>                                          
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                           
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Sub-Process</InputLabel>
                                                        <Select value={fileData?.sub_process_id ??''}
                                                            sx={{
                                                                '&:before': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:after': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:hover:not(.Mui-disabled):before': {
                                                                    borderBottom: 'none',
                                                                }}}
                                                                            size="small" label="Sub-Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'sub_process','documents_name_not_found')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData &&  item.parent===fileData.process_id ).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>                                            
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2} >                                            
                                                    <TextField fullWidth    label="Valid Upto"  variant="standard"    inputProps={{min: new Date().toISOString().split('T')[0]}}  InputProps={{ disableUnderline: true }} 
                                                    size="small" type="date"  onKeyDown={(e)=>e.preventDefault()}  value={fileData?.valid_upto ??''}  onChange={(e)=>{updateValidationFileData(e.target.value ,fileIndex,'valid_upto','documents_name_not_found')}}  InputLabelProps={{shrink: true}}/>                                                                                                
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}> 
                                            <Grid container spacing={1}> 
                                                <Grid item  xs={10}>
                                                    <TextField key={`${fileData.owner??''}-${fileIndex}nf`} fullWidth  variant="standard" InputProps={{ disableUnderline: true }}   size="small" label="Enter Owner Name" defaultValue={fileData?.owner ??''}   onBlur={(e)=>{updateValidationFileData(e.target.value.trimStart() ,fileIndex,'owner','documents_name_not_found')}} />                                                                        
                                                </Grid>
                                                <Grid item  xs={2} sx={{pr:'0.3rem',cursor:'pointer'}} alignSelf='end' onClick={()=>removeRowFromValidationUpload(fileIndex,'documents_name_not_found')}>               
                                                    <RemoveCircleOutlineIcon  sx={{color:'#757D99'}}/> 
                                                </Grid>   
                                                </Grid>                                                                                                            
                                            </GridWithBorder>
                                        </Grid>                                       
                                        ))
                                    }                                                    
                            </AccordionDetails>
                        </Accordion>}
                    </Box>
                    <Box sx={{marginTop: '1rem'}}>
                        {uploadValidationDocs && uploadValidationDocs.documents_already_present && uploadValidationDocs.documents_already_present.length>0 &&   <Accordion elevation={0} sx={{border:'1px solid #E9EAEE',borderRadius:'9px'}} >
                            <AccordionSummary  expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem',bgcolor:'light.main',color:'light.contrastText' }}  />}         
                                sx={{
                                flexDirection: 'row-reverse',  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                    transform: 'rotate(90deg)',
                                }}}>
                                <Typography sx={{paddingLeft:'1rem'}}>Document(s) already exist</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{padding:0}}>
                                <Grid container spacing={0} sx={{background:'#F5F5F5',color:'#777F9B'}}>
                                    <GridWithBorder item xs={2} >                                       
                                            <Typography variant="subtitle1">DOC NAME</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">DOMAIN</Typography>                                     
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">PROCESS</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">SUB PROCESS</Typography>                                       
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                     
                                            <Typography variant="subtitle1">VALID UPTO</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                  
                                            <Typography variant="subtitle1">OWNER</Typography>                                        
                                    </GridWithBorder>
                                </Grid >
                                      
                                   {  uploadValidationDocs.documents_already_present.map((fileData,fileIndex)=>(
                                        <Grid container spacing={0}>
                                            <GridWithBorder item xs={2}>                                                                                                   
                                                    <TextField 	key={`${fileData.file_name??''}-${fileIndex}ap`} label="Doc Name"  variant="standard"  InputProps={{ disableUnderline: true }} fullWidth  size="small"  defaultValue={ fileData?.file_name ??'' } onBlur={(e)=>{ updateValidationFileData(e.target.value.trimStart() ,fileIndex,'file_name','documents_already_present')}}  />                                                    
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                              
                                                    <FormControl fullWidth variant="standard" >
                                                        <InputLabel>Domain</InputLabel>
                                                        <Select  sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} value={fileData?.domain_id ??''} size="small" label="Select Domain" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'domain','documents_already_present')}>
                                                        
                                                        {adminmenu&&adminmenu.filter(item=> item.parent === "").map((obj)=>{
                                                            return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                                        })}
                                                        </Select>
                                                    </FormControl>                                                
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                               
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Process</InputLabel>
                                                        <Select value={fileData?.process_id ??''}   sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} size="small" label="Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'process','documents_already_present')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData && item.parent===fileData.domain_id).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>                                                
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                                
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Sub-Process</InputLabel>
                                                        <Select value={fileData?.sub_process_id??''}
                                                            sx={{
                                                                '&:before': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:after': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:hover:not(.Mui-disabled):before': {
                                                                    borderBottom: 'none',
                                                                }}}
                                                                            size="small" label="Sub-Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'sub_process','documents_already_present')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData  && item.parent===fileData.process_id ).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>           
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2} >                                              
                                                    <TextField fullWidth    label="Valid Upto"  variant="standard"    inputProps={{min: new Date().toISOString().split('T')[0]}}  InputProps={{ disableUnderline: true }} 
                                                    size="small" type="date" onKeyDown={(e)=>e.preventDefault()}  value={fileData?.valid_upto??''}  onChange={(e)=>{updateValidationFileData(e.target.value ,fileIndex,'valid_upto','documents_already_present')}}  InputLabelProps={{shrink: true}}/>                                                                                           
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>  
                                                <Grid container spacing={1}>
                                                    <Grid item xs={10}>
                                                        <TextField 	key={`${fileData.owner??''}-${fileIndex}ap`} fullWidth  variant="standard" InputProps={{ disableUnderline: true }}   size="small" label="Enter Owner Name" defaultValue={fileData?.owner ??''}   onBlur={(e)=>{updateValidationFileData(e.target.value.trimStart() ,fileIndex,'owner','documents_already_present')}} />   
                                                    </Grid>   
                                                    <Grid item  xs={2}  sx={{pr:'0.3rem',cursor:'pointer'}} alignSelf='end' onClick={()=>removeRowFromValidationUpload(fileIndex,'documents_already_present')}>               
                                                    <RemoveCircleOutlineIcon  sx={{color:'#757D99'}}/> 
                                                </Grid>                                                                                                           
                                                </Grid>                                                                         
                                            </GridWithBorder>
                                        </Grid>                                         
                                        ))
                                    }                                                    
                            </AccordionDetails>
                            </Accordion>
                        }              
                    </Box>  
                    <Box sx={{marginTop: '1rem'}}>
                        {uploadValidationDocs && uploadValidationDocs.documents_size_exceeded && uploadValidationDocs.documents_size_exceeded.length>0  && <Accordion elevation={0} sx={{border:'1px solid #E9EAEE',borderRadius:'9px'}} >
                            <AccordionSummary  expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem',bgcolor:'light.main',color:'light.contrastText' }}  />}         
                                sx={{
                                flexDirection: 'row-reverse',  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                    transform: 'rotate(90deg)',
                                }}}>
                                <Typography sx={{paddingLeft:'1rem'}}>Document(s) size exceeded</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{padding:0}}>
                                <Grid container spacing={0} sx={{background:'#F5F5F5',color:'#777F9B'}}>
                                    <GridWithBorder item xs={2} >                                       
                                            <Typography variant="subtitle1">DOC NAME</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">DOMAIN</Typography>                                     
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">PROCESS</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2} >                                      
                                            <Typography variant="subtitle1">SUB PROCESS</Typography>                                       
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                     
                                            <Typography variant="subtitle1">VALID UPTO</Typography>                                      
                                    </GridWithBorder>
                                    <GridWithBorder item xs={2}>                                  
                                            <Typography variant="subtitle1">OWNER</Typography>                                        
                                    </GridWithBorder>
                                </Grid >
                                      
                                   {  uploadValidationDocs.documents_size_exceeded.map((fileData,fileIndex)=>(
                                        <Grid container spacing={0}>
                                            <GridWithBorder item xs={2}>                                                                                                   
                                                    <TextField  key={`${fileData.file_name??''}-${fileIndex}se`} label="Doc Name"  variant="standard"  InputProps={{ disableUnderline: true }} fullWidth  size="small"  defaultValue={ fileData?.file_name ??'' } onBlur={(e)=>{ updateValidationFileData(e.target.value.trimStart() ,fileIndex,'file_name','documents_size_exceeded')}}  />                                                    
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                              
                                                    <FormControl fullWidth variant="standard" >
                                                        <InputLabel>Domain</InputLabel>
                                                        <Select  sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} value={fileData?.domain_id ??''} size="small" label="Select Domain" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'domain','documents_size_exceeded')}>
                                                        
                                                        {adminmenu&&adminmenu.filter(item=> item.parent === "").map((obj)=>{
                                                            return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                                        })}
                                                        </Select>
                                                    </FormControl>                                                
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                               
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Process</InputLabel>
                                                        <Select value={fileData?.process_id ??''}   sx={{
                                                                        '&:before': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:after': {
                                                                            borderBottom: 'none',
                                                                        },
                                                                        '&:hover:not(.Mui-disabled):before': {
                                                                            borderBottom: 'none',
                                                                        }}} size="small" label="Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'process','documents_size_exceeded')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData && item.parent===fileData.domain_id).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>                                                
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}>                                                
                                                    <FormControl fullWidth variant="standard">
                                                        <InputLabel>Sub-Process</InputLabel>
                                                        <Select value={fileData?.sub_process_id??''}
                                                            sx={{
                                                                '&:before': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:after': {
                                                                    borderBottom: 'none',
                                                                },
                                                                '&:hover:not(.Mui-disabled):before': {
                                                                    borderBottom: 'none',
                                                                }}}
                                                                            size="small" label="Sub-Process" onChange={(e)=>updateValidationDocsMenu(e.target.value,fileIndex,'sub_process','documents_size_exceeded')}>
                                                            {adminmenu&&adminmenu.filter(item=>fileData && item.parent===fileData.process_id ).map((menu)=>{
                                                                return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>           
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2} >                                              
                                                    <TextField fullWidth    label="Valid Upto"  variant="standard"    inputProps={{min: new Date().toISOString().split('T')[0]}}  InputProps={{ disableUnderline: true }} 
                                                    size="small" type="date" onKeyDown={(e)=>e.preventDefault()}  value={fileData?.valid_upto??''}  onChange={(e)=>{updateValidationFileData(e.target.value ,fileIndex,'valid_upto','documents_size_exceeded')}}  InputLabelProps={{shrink: true}}/>                                                                                           
                                            </GridWithBorder>
                                            <GridWithBorder item xs={2}> 
                                                <Grid container spacing={1}>
                                                <Grid item  xs={10}>
                                                <   TextField 	key={`${fileData.owner??''}-${fileIndex}se`} fullWidth  variant="standard" InputProps={{ disableUnderline: true }}   size="small" label="Enter Owner Name" defaultValue={fileData?.owner ??''}   onBlur={(e)=>{updateValidationFileData(e.target.value.trimStart() ,fileIndex,'owner','documents_size_exceeded')}} />                                                                           
                                                </Grid>   
                                                <Grid item  xs={2}  sx={{pr:'0.3rem',cursor:'pointer'}} alignSelf='end' onClick={()=>removeRowFromValidationUpload(fileIndex,'documents_size_exceeded')}>               
                                                    <RemoveCircleOutlineIcon  sx={{color:'#757D99'}}/> 
                                                </Grid>  
                                                </Grid>                                                                                                         
                                            </GridWithBorder>
                                        </Grid>                                         
                                        ))
                                    }                                                    
                            </AccordionDetails>
                            </Accordion>
                        }              
                    </Box>                 
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='primary' onClick={resetValidationDocs}>Delete Request</Button>
                    <Button variant='contained' color='primary' onClick={()=> handleValidationSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showValidationInProgress} TransitionComponent={Transition} keepMounted onClose={()=> setShowValidationInProgress(false)}>    
                <DialogContent>
                    <Typography align="center" variant="h5" style={{ fontWeight: 'bold' }} color="error">Documents validation in progress,please try later!</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='primary' onClick={()=> setShowValidationInProgress(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog fullWidth open={ showEditPop} TransitionComponent={Transition} keepMounted onClose={()=>  handleEditPopToggle()}>
                <DialogTitle>Edit Document</DialogTitle>
                <DialogContent ref={editPopRef}>
                    <Box sx={{marginTop: '1rem'}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        border: '2px dashed #aaa',
                                        borderRadius: '4px',
                                        padding: '16px',
                                        textAlign: 'center',
                                        backgroundColor: isDragging ? '#f0f0f0' : '#fff',
                                        cursor: 'pointer',
                                    }}
                                    onDragEnter={handleDragEnter}
                                    onDragLeave={handleDragLeave}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                    onClick={() => document.getElementById('fileInput').click()}
                                    >
                                    <Upload/>
                                    <Typography variant="body1">
                                        {isDragging ? 'Drop your file here' : 'Drag and drop a file here or click to upload'}
                                    </Typography>
                                    <VisuallyHiddenInput
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=>handleFile(e.target.files[0])}
                                    />
                                    <Typography variant="subtitle2">Supported File Formats: 
                                        {appConfigs.allowedFileTypes.map((type)=>{
                                            return " "+type+" "
                                        })}
                                    </Typography>
                                    {documentName&&<Typography color='secondary.main' variant="body1" sx={{wordWrap:'break-word'}}>{documentName}</Typography>}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth size="small" label="Document Name" variant="outlined"  sx={{wordWrap:'break-word'}} value={documentName} disabled />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Process</InputLabel>
                                    <Select sx={{padding: '0.25rem !important'}} value={documentProcess ?documentProcess:''} size="small" label="Process" onChange={(e)=>{setDocumentProcess(e.target.value)}}>
                                        {adminmenu&&adminmenu.filter(item=>item.parent===selectedDomain).map((menu)=>{
                                            return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Process</InputLabel>
                                    <Select sx={{padding: '0.25rem !important'}} value={documentSubProcess?documentSubProcess:''} size="small" label="Sub Process" onChange={(e)=>{setDocumentSubProcess(e.target.value)}}>
                                        {adminmenu&&adminmenu.filter(item=>item.parent===documentProcess).map((menu)=>{
                                            return <MenuItem key={menu.id} value={menu.id}>{menu.name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth size="small" label="Document Owner" inputProps={{ maxLength: appConfigs.docNameCount }}  variant="outlined" value={documentOwner} onChange={(e)=>setDocumentOwner(e.target.value)} />
                                <Typography variant="body2" color="textSecondary">
                                     Max {appConfigs.docNameCount } characters allowed
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                    <TextField onKeyDown={(e)=>e.preventDefault()} fullWidth label="Valid Upto" type="date" value={documentValidUpto} onChange={(e)=>setDocumentValidUpto(e.target.value)} InputLabelProps={{shrink: true}}/>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel value={legalApprovals} control={<Checkbox checked={legalApprovals} onChange={() => setLegalApprovals(!legalApprovals)} />} label="Legal Approvals done for the document?" />
                            </Grid>

                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> handleEditPopToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} disabled={!legalApprovals || !documentOwner} variant='contained' color='primary' onClick={()=> handleEditSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showDeletePop} TransitionComponent={Transition} keepMounted onClose={()=> setShowDeletePop(false)}>
                <DialogTitle>Delete Document</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to delete the selected Document?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> setShowDeletePop(false)}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleDeleteSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showDeleteMultiPop} TransitionComponent={Transition} keepMounted onClose={()=> setShowDeleteMultiPop(false)}>
                <DialogTitle>Delete Multiple Document(s)</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to delete the selected Document(s)?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> setShowDeleteMultiPop(false)}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleMultiDeleteSubmit(selectedRecords)}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showMasterSOPPop} TransitionComponent={Transition} keepMounted onClose={()=> setShowMasterSOPPop(false)}>
                <DialogTitle>Master SOP Request Placed</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>{appConfigs.masterSOPDisclaimer}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> setShowMasterSOPPop(false)}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleMasterSOPSubmit(selectedRecords)}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showMasterSOPSuccessPop} TransitionComponent={Transition} keepMounted onClose={()=> setShowMasterSOPSuccessPop(false)}>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>The master SOP request has been placed and will be soon available on Generated Master SOPs tab.</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> setShowMasterSOPSuccessPop(false)}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth fullScreen open={showDocumentViewer} TransitionComponent={Transition} keepMounted onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>
                <DialogTitle>
                    <IconButton
                    onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}
                    sx={{ color: "#000000", float: 'right'}} >
                    <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DocViewer link={documentObject} downloadable={appConfigs.allowDocDownload} />
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}